import React, { useState } from 'react';
import Menu from "../components/common/menu/Menu";
import Sidebar from "../components/common/menu/Sidebar";
import { Card, CardBody, Typography } from "@material-tailwind/react";

// Inventory analytics
import GrossProfitCard from "../components/inventory/analytics/GrossProfitCard";
import NetProfitCard from "../components/inventory/analytics/NetProfitCard";
import TotalSalesRevenueCard from "../components/inventory/analytics/TotalSalesRevenueCard";
import TotalInventoryCostCard from "../components/inventory/analytics/TotalInventoryCostCard";
import InventoryValueCard from "../components/inventory/analytics/InventoryValueCard";
import CostOfGoodsSoldCard from "../components/inventory/analytics/CostOfGoodsSoldCard";
import OperatingExpensesCard from "../components/inventory/analytics/OperatingExpensesCard";
import ProfitMarginCard from "../components/inventory/analytics/ProfitMarginCard";
import TotalPersonalCostCard from "../components/inventory/analytics/TotalPersonalCostCard";
import FinancialReportCard from "../components/inventory/analytics/FinancialReportCard";
import DailyProfitCard from "../components/inventory/analytics/DailyProfitCard";

// Figures analytics
import TotalInventoryCostCardFigure from "../components/figures/analytics/TotalInventoryCostCardFigure";
import InventoryValueCardFigure from "../components/figures/analytics/InventoryValueCardFigure";
import TotalSalesRevenueCardFigure from "../components/figures/analytics/TotalSalesRevenueCardFigure";
import CostOfGoodsSoldCardFigure from "../components/figures/analytics/CostOfGoodsSoldCardFigure";
import GrossProfitCardFigure from "../components/figures/analytics/GrossProfitCardFigure";
import ProfitMarginCardFigure from "../components/figures/analytics/ProfitMarginCardFigure";
import FinancialReportCardFigure from "../components/figures/analytics/FinancialReportCardFigure";
import DailyProfitCardFigure from "../components/figures/analytics/DailyProfitCardFigure";

function DashboardPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = (isOpen) => {
        setSidebarOpen(isOpen);
    };

    return (
        <div className="overflow-hidden dark:bg-dark-950">
            <div className="block md:hidden">
                <Menu sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
            </div>

            <div className="hidden md:block ">
                <Sidebar />
            </div>

            <div className="md:ml-[15rem] bg-light-blue-50 relative dark:bg-dark-950">
                <div className="absolute inset-0 opacity-[0.04] dark:opacity-0" style={{
                    backgroundImage: 'url(https://i.ibb.co/9kYFDXtW/background-manga.jpg)',
                    backgroundSize: 'cover',
                }}></div>
                <div className="container mx-auto relative">
                    <div className="flex justify-center items-center">
                        <div className="w-full max-w-6xl mt-8 lg:mt-20 mb-24">

                            {/* Inventory Analytics */}
                            <div className="mb-8 mx-2 lg:mx-20 grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <Card className="w-full shadow-lg dark:bg-dark-900">
                                    <CardBody>
                                        <Typography variant="h5" color="blue-gray" className="mb-1 dark:text-gray-300">
                                            Inventory
                                        </Typography>
                                        <Typography variant="small" className="text-gray-500 dark:text-gray-500 mb-3">
                                            Inventory & costs overview
                                        </Typography>
                                        <hr className="mb-2 border-blue-gray-50 dark:border-gray-700" />
                                        <div className="flow-root">
                                            <ul className="divide-y divide-gray-200 dark:divide-gray-800">
                                                <InventoryValueCard />
                                                <TotalPersonalCostCard />
                                                <TotalInventoryCostCard />
                                                <TotalSalesRevenueCard />
                                                <CostOfGoodsSoldCard />
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Card>

                                <Card className="w-full shadow-lg dark:bg-dark-900">
                                    <CardBody>
                                        <Typography variant="h5" color="blue-gray" className="mb-1 dark:text-gray-300">
                                            Inventory
                                        </Typography>
                                        <Typography variant="small" className="text-gray-500 dark:text-gray-500 mb-3">
                                            Profit & reports
                                        </Typography>
                                        <hr className="mb-2 border-blue-gray-50 dark:border-gray-700" />
                                        <div className="flow-root">
                                            <ul className="divide-y divide-gray-200 dark:divide-gray-800">
                                                <GrossProfitCard />
                                                <OperatingExpensesCard />
                                                <NetProfitCard />
                                                <ProfitMarginCard />
                                                <FinancialReportCard />
                                                <DailyProfitCard />
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>

                            {/* Figures Analytics */}
                            <div className="mb-8 mx-2 lg:mx-20 grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <Card className="w-full shadow-lg dark:bg-dark-900">
                                    <CardBody>
                                        <Typography variant="h5" color="blue-gray" className="mb-1 dark:text-gray-300">
                                            Pop! Figures
                                        </Typography>
                                        <Typography variant="small" className="text-gray-500 dark:text-gray-500 mb-3">
                                            Inventory & costs overview
                                        </Typography>
                                        <hr className="mb-2 border-blue-gray-50 dark:border-gray-700" />
                                        <div className="flow-root">
                                            <ul className="divide-y divide-gray-200 dark:divide-gray-800">
                                                <InventoryValueCardFigure />
                                                <TotalInventoryCostCardFigure />
                                                <TotalSalesRevenueCardFigure />
                                                <CostOfGoodsSoldCardFigure />
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Card>

                                <Card className="w-full shadow-lg dark:bg-dark-900">
                                    <CardBody>
                                        <Typography variant="h5" color="blue-gray" className="mb-1 dark:text-gray-300">
                                            Pop! Figures
                                        </Typography>
                                        <Typography variant="small" className="text-gray-500 dark:text-gray-500 mb-3">
                                            Profit & reports
                                        </Typography>
                                        <hr className="mb-2 border-blue-gray-50 dark:border-gray-700" />
                                        <div className="flow-root">
                                            <ul className="divide-y divide-gray-200 dark:divide-gray-800">
                                                <GrossProfitCardFigure />
                                                <ProfitMarginCardFigure />
                                                <FinancialReportCardFigure />
                                                <DailyProfitCardFigure />
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardPage;
